/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { GET_STUDENT_GIA_LIST } from '../../actions';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IGiaItem } from '../../api/types';

import genericReducers from '../genericReducer';

import { IReducers } from '..';

export type StudentGiaListState = ICommonResponse<IGiaItem>;

const initialState: StudentGiaListState = {
  content: [],
  loading: false,
  requestCache: 'notCached',
};
const generic = genericReducers<StudentGiaListState>();
const studentGiaList: IReducers<StudentGiaListState> = {
  [GET_STUDENT_GIA_LIST[REQUEST]]: generic.get.request,
  [GET_STUDENT_GIA_LIST[SUCCESS]]: generic.get.success,
  [GET_STUDENT_GIA_LIST[FAILURE]]: generic.get.failure,
  [GET_STUDENT_GIA_LIST[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentGiaList);
